import { PropType, computed, defineComponent, onUnmounted, ref, watch } from 'vue'
// import { MapContext as ChargeMapContext } from '@/components/ChargerMap/index.model'
import { Store } from 'pinia'
import { useRoute } from 'vue-router'
import { ChargeMapContext } from '../chargerMap/index.model'
import { ComponentActions, ComponentState } from '../../nsh5/localStores/component'
import { Marker, Point, PowerResource } from '../../contract/map'
import { addResourceCircle, removeResourceCircle } from '../chargerMap/mapUtils'
// import { Marker, Point } from '@/contract/map.base'
// import { IMarker, PowerResource } from '../iconRender/icon.model'
// import { ComponentActions, ComponentState } from '../map/localStores/component'
// import { addResourceCircle, removeResourceCircle } from '@/components/ChargerMap/mapUtil'

/**
 * 城市电区房渲染功能模块
 */
export default defineComponent({
  name: 'circle-render-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    mapInstance: {
      type: Object,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },

  setup: (props, { expose }) => {
    const mapContextRef = computed(() => props.mapContextRef)
    const mapInstance = computed(() => props.mapInstance)
    // const mapContextRef = ref<ChargeMapContext>()
    // const mapInstance = ref<any>()
    const zoomLevel = ref<number>(0)
    const route = useRoute()
    const clickedMarkerMap: {
      [id: string]: Marker
    } = {}
    let id = ''

    const drawCircle = (resources: PowerResource[], loc?: Point) => {
      // TODO 可以添加filter判断
      removeResourceCircle(mapContextRef.value!)
      addResourceCircle(mapContextRef.value!, resources, loc)
    }

    /**
     * 其他场景直接画圈
     */
    props.componentStore.bus.on('clickedMarker', (customMarkerData: Marker) => {
      // 不通过监听url变化来判断，因为会有直接进入的情况
      clickedMarkerMap[customMarkerData.id] = customMarkerData
    })

    const onDrawPowerSwapCircle = () => {
      id = (route.query.id as string) || ''
      try {
        if (id) {
          const customMarkerData = clickedMarkerMap[id]
          const resource: any = customMarkerData?.data
          if (
            resource &&
            (resource.pointType == 'recharge' || resource.pointType == 'recharge|ps') &&
            resource.pointSubType == 'PowerSwap'
          ) {
            drawCircle([resource])
          } else {
            removeResourceCircle(mapContextRef.value!)
          }
        }
      } catch (error) {
        console.log('==============error onDrawPowerSwapCircle======================')
      }
    }

    // ------------暴露出去的方法--------------
    const zoomEnd = async () => {
      zoomLevel.value = mapInstance.value?.getZoom()
    }
    expose({
      zoomEnd,
    })

    // 启动相关事件监听
    const initEventListener = () => {
      mapInstance.value?.addEventListener('zoomend', zoomEnd, false)
    }

    // // unmounted时摧毁相关事件监听
    // const destroyEventListener = () => {
    //   mapInstance.value?.removeEventListener('zoomend', zoomEnd, false)
    // }

    onUnmounted(() => {
      // destroyEventListener()
      props.componentStore.bus.off('clickedMarker')
    })

    /**
     * 组件获取地图实例后的回调
     */
    const onReady = () => {
      // mapInstance.value = mapContextRef.value?.getMap()
      initEventListener()
    }
    watch(
      () => props.mapContextRef,
      () => {
        if (props.mapContextRef) {
          // mapContextRef.value = props.mapContextRef
          onReady()
        }
      },
      {
        immediate: true,
      }
    )
    watch(
      () => route.query.id,
      () => {
        if (route.name == 'resource') {
          // icon点之间的切换
          onDrawPowerSwapCircle()
        }
      }
    )
    watch(
      () => route.name,
      (newVal, oldVal) => {
        if (newVal !== 'resource' && oldVal === 'resource') {
          // 取消换电站的电区房圈
          removeResourceCircle(mapContextRef.value!, [id])
          id = ''
        }
      }
    )
    return () => {}
  },
})
